{
  "BANNER": {
    "TITLE": "Connect with the right kind of care",
    "DESCRIPTION": "We take care of your every day and large healthcare needs. Take care of yourself and we will take care of the rest. Get your first month membership in just $29.99.",
    "BTNTEXT": "Get Started Now"
  },
  "FEATURE": {
    "TITLE": "Featured in"
  },
  "SEARCH": {
    "HEADING": "Search medications near you",
    "FORMULARY": "Your membership gets you this medicine for free, and it's delivered to your doorstep at no extra cost.",
    "INPUT": {
      "PLACEHOLDER": "Search by drug name",
      "HEADING": "Search for Medicines",
      "SUBHEADING": "You can search for the medication you need!"
    },
    "BUTTON": "Download Card",
    "MODAL": {
      "HEADING": "Download Card",
      "DESCRIPTION": "Please select who you want to download the discount card for.",
      "BUTTON": "Download Card"
    },
    "PRESCRIPTION": {
      "HEADING": "Direct Prescription",
      "EMPTYZIPCODE": "Please Select Zip Code.",
      "DESCRIPTION": "Have your doctor prescribe directly to us and avail free home delivery.",
      "BUTTON": "Recommended",
      "FILTER": {
        "HEADING": "Personalize Your Search",
        "BUTTON": "Apply"
      },
      "CONTENT": {
        "ELECTRONIC": "Prescribe Electronically",
        "FAX": "Prescribe via Fax",
        "PHONE": "Prescribe via Phone"
      },
      "TRANSFER": {
        "HEADING": "Transfer Prescription",
        "DESCRIPTION": "Move your eligible prescriptions for zero cost and free home delivery (2-3 weeks).",
        "BUTTON": "Transfer"
      },
      "PICKUP": {
        "HEADING": "Pick- up at Pharmacy",
        "DESCRIPTION": "Show the discount card at a local pharmacy and get this medication for free.",
        "BUTTON": "Download Card"
      }
    },
    "FILTER": {
      "HEADING": "Prices available at the pharmacies",
      "BUTTON": "Filters",
      "SORT": "Sort"
    }
  },
  "BENEFITS": {
    "TITLE": "Benefits you get",
    "DESCRIPTION": "Membership that puts control back in your hands, with a community behind you ",
    "BOX1": {
      "TITLE": "Peace of Mind",
      "DESCRIPTION": " Our members have full transparency and control over their medical decisions, with no long-term commitments."
    },
    "BOX2": {
      "TITLE": "Simple Model",
      "DESCRIPTION": "Discounted direct-pay rates for routine Everyday Care. Option to add HealthShare for large medical needs like ER visits, hospitalizations, pregnancy, etc."
    },
    "BOX3": {
      "TITLE": "No Restrictions",
      "DESCRIPTION": "No annual or lifetime caps on services. Nationwide access including global protection while traveling"
    }
  },
  "FEELBETTER": {
    "MINI_TITLE": "What we treat?",
    "TITLE": "How can we help you feel better?",
    "BOX1": {
      "TITLE": "Virtual Urgent Care",
      "DESCRIPTION": "Free 24/7 access to a doctor without the wait or cost of office visits."
    },
    "BOX2": {
      "TITLE": "Mental Health",
      "DESCRIPTION": "Free sessions with certified counselors to assist with the stressors of life."
    },
    "BOX3": {
      "TITLE": "Medications",
      "DESCRIPTION": "Up to 400 generic medications at no cost"
    },
    "BOX4": {
      "TITLE": "Complete Care",
      "DESCRIPTION": "Regardless of your medical needs, we have services to address all of them. "
    }
  },
  "BENIFITSMEMBERSHIP": {
    "MINI_TITLE": "How it Works",
    "TITLE": "Benefits of our membership",
    "BENIFIT1": "Free 24/7 Telemedicine access to a doctor, and mental health counselors",
    "BENIFIT2": "Nationwide community of direct-pay providers, across all aspects of healthcare",
    "BENIFIT3": "Simple app and workflows for everyone, not just some medical experts",
    "BENIFIT4": "No long term commitments with monthly plans to our member only community",
    "BENIFIT5": "Transparent pricing without need for approvals for all healthcare needs",
    "BENIFIT6": "24/7 customer support to assist with any questions"
  },
  "MONTHLYMEMBERSHIP": {
    "TITLE": "Get your monthly membership for only $29.99",
    "DESCRIPTION": "Comprehensive healthcare without the high costs of premiums and complexities of insurance",
    "BTNTEXT": "Get Started"
  },
  "BLOG": {
    "MINI_TITLE": "Join the community",
    "TITLE": "Partner with us to provide meaningful benefits with control and transparency"
  },
  "TESTIMONIALS": {
    "MINI_TITLE": "Testimonials",
    "TITLE": "See how we've helped our members by hearing their stories."
  },
  "HELP": {
    "MINI_TITLE": "How can we help?",
    "TITLE": "Talk to us or explore our FAQ page",
    "BOX1": {
      "TITLE": "Talk to customer support",
      "DESCRIPTION": "Chat or speak to one of our member support representatives, 24/7. We strive to provide the very best care of all of our members."
    },
    "BOX2": {
      "TITLE": "Visit FAQ page",
      "DESCRIPTION": " We have answered many questions that you may have, and some that you may not have thought of yet! Connect with us if we can help in any way."
    }
  },
  "language": "en",
  "FAQS": {
    "MINI_TITLE": "How it works",
    "TITLE1": "Frequently",
    "TITLE2": "Asked Questions",
    "DESCRIPTION": "Need help? Reach out to our 24/7 customer support at  <a class='phone' href='tel:8449694325'>844-969-4325</a> and get the assistance you need.",
    "LINK": "Visit Faqs Page",
  "FAQ_LIST": [
    {
      "title": "What benefits are included with my membership?",
      "description": "Depending on your plan, your membership may include:<br><ul><li>Virtual primary care</li><li>24/7 virtual urgent care</li><li>Mental health counseling</li><li>Pharmacy benefits</li><li>Dental savings</li><li>Vision care benefits</li></ul><br>Services may vary according to your specific plan."
    },
    {
      "title": "How do I access my health benefits?",
      "description": "Simply log in to your WoW Health account and access your member dashboard. From there, you can browse available services, search for providers, access virtual care, and manage your healthcare benefits."
    },
    {
      "title": "What conditions can Virtual Urgent Care help with?",
      "description": "Our 24/7 Virtual Urgent Care can help with many common, non-emergency conditions, including:<br><ul><li>Cold and flu symptoms</li><li>Allergies</li><li>Sinus infections</li><li>Minor skin conditions</li><li>Urinary tract infections (UTIs)</li><li>Prescription refills when appropriate</li><li>Other routine health concerns</li></ul>"
    },
    {
      "title": "How do I access Virtual Urgent Care?",
      "description": "Our 24/7 virtual urgent care is easily accessible in these simple steps:<br><ol><li>Log in to your WoW account</li><li>Go to your dashboard</li><li>Select ‘See A Doctor’</li><li>Select ‘Virtual Urgent Care’</li><li>Complete visit details in the portal.</li><li>Get connected with the doctor (usually within 30 minutes).</li><li>If needed, the doctor will send the prescription to your local pharmacy.</li></ol><br>"
    },
    {
      "title": "How does the dental benefit work?",
      "description": "Members can access discounted dental services through a nationwide network of participating dental providers. Savings up to 60% may be available on routine cleanings, X-rays, fillings, crowns, and other common dental procedures."
    },
    {
      "title": "How do I find a participating dentist?",
      "description": "Members can search for dentists within WoW Health's nationwide network of over 263,000 dental practice locations. This can simply be done from your dashboard under the dental care section."
    },
    {
      "title": "How does the vision benefit work?",
      "description": "The vision benefit provides savings on glasses and contact lenses, access to over 100,000 vision providers nationwide, a free online eye exam where permitted, AI-powered frame try-on tools, and convenient home delivery of eyewear."
    },
    {
      "title": "How do I book a vision appointment?",
      "description": "Members can book a vision appointment from our 100,000+ providers nationwide in three simple steps:<br><ol><li>Access the vision portal by clicking the button below.</li><li>Fill in your basic information to complete the enrollment.</li><li>Avail your benefits in a few easy clicks.</li></ol>"
    },
    {
      "title": "What is the WoW Health Pharmacy plan?",
      "description": "Our pharmacy plan provides access to the top 93% commonly prescribed medications at $0 cost when filled at participating local pharmacies. The plan also includes access to significant discounts on medications not covered under the $0 list."
    },
    {
      "title": "How can I get my medications?",
      "description": "Getting your medications is super easy.<br><ol><li>Go to your ‘Dashboard.’</li><li>Click the ‘medications’ tab</li><li>Search for the medicines you need.</li><li>Select the medicine and click ‘search.’</li><li>Select the local pharmacy of your preference</li></ol><br>Once done, you can simply pick up your medication from a local pharmacy. Eligible medications are available either completely free or at a discounted price."
    },
    {
      "title": "If I go to the pharmacy, do I need to show my membership card?",
      "description": "Yes, when filling a prescription, you should present your pharmacy card at the pharmacy so the pharmacist can apply your benefit and process the correct pricing under the plan."
    },
    {
      "title": "What if I need a medication urgently?",
      "description": "In urgent situations such as infections or acute illness, you can visit a participating local pharmacy and obtain coverage for many common urgent care medications at $0 cost, so you do not need to wait for processing or additional steps."
    },
    {
      "title": "What happens if my medication is not covered?",
      "description": "If your medication is not on the $0 coverage list, it will still be available at a discounted rate. You can check if your medication is fully covered on your dashboard."
    },
    {
      "title": "Can I switch between medications or pharmacies?",
      "description": "Yes, you can continue using your benefit across participating pharmacies. If your doctor changes your prescription, the updated medication can also be processed through your WoW Health pharmacy benefit."
    },
    {
      "title": "How can I get help if I have questions?",
      "description": "Our Member Support team is available 24/7 to assist with questions about your benefits, account access, eligibility, and available services."
    }
  ] 
  }

}